export default function ({store, $config}) {
  const scriptsList = [
    { src: '/js/hotjar.js', body: true },
    { src: '/js/fb-pixel.js', body: true, async: true },
    { src: `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${$config.KLAVIYO_PUBLIC_KEY}`, body: true, async: true },
    { src: 'https://static.zdassets.com/ekr/snippet.js?key=7cfb95ce-1ee2-4e9a-8f6d-dfa4c046fa98', body: true, async: true, id: 'ze-snippet' },
    { src: 'https://www.dwin1.com/19038.js', body: true, defer: true },
    // {
    //   id: 'Cookiebot',
    //   src: 'https://consent.cookiebot.com/uc.js',
    //   'data-cbid': 'ab050738-0a54-42df-b5d7-14a633d7c01b',
    //   'data-blockingmode': 'auto',
    //   'data-georegions': "{'region':'US-08','cbid':'80265cee-e6e3-477d-8b4b-c43579789acc'},{'region':'US-09','cbid':'b900b774-4522-4998-939e-ba42b25cac2f'},{'region':'US-49','cbid':'a76a7813-00cc-4104-b047-560bbd679dc4'},{'region':'US-51','cbid':'54b17b02-a80a-42fb-964f-b4b734207449'},{'region':'BE, BG, HR, CY, CZ, DK, EE, FI, FR, DE, GR, HU, IE, IT, LV, LT, LU, MT, NL, PL, PT, RO, SK, SI, ES, SE','cbid':'9073ada3-8985-4c8b-a794-a2642e17acfd'}",
    // },
  ];

  function insertScript (scriptContext) {
    const script = document.createElement('script');
    for (let key in scriptContext) {
      let value = scriptContext[key];
      if (key === 'async' || key === 'defer') {
        value = '';
      }
      if (key !== 'body') {
        script.setAttribute(key, value);
      }
    }
    const scriptParentElement = scriptContext.body ? document.body : document.head;
    scriptParentElement.appendChild(script);
  }

  setTimeout(() => {
    scriptsList.forEach(item => {
      insertScript(item);
    });
  }, store.getters.getAnalyticsMarketingLoadTimeout);
}
